import { createEventDefinition } from "ts-bus";

export const serverErrorOccurred = createEventDefinition<{
    message: string;
}>()("GLOBAL.SERVER_ERROR");

export const fileUploadErrorOccurred = createEventDefinition<{
    message: string;
}>()("GLOBAL.FILE_UPLOAD_ERROR");